module.exports = __webpack_public_path__ + "media/images/icons/edit-icon-106d0db35abbcaaccabd5cb2b4fb335c.svg";